import PhoneIcon from '@/components/Icons/PhoneIcon.vue'
import LetterIcon from '@/components/Icons/LetterIcon.vue'
import LocationIcon from '@/components/Icons/LocationIcon.vue'

export const contacts = [
    {
        icon: PhoneIcon,
        title: '(+380) 50 130 45 18',
        href: 'tel:380501304518',
    },
    {
        icon: LetterIcon,
        title: 'jiskelo@gmail.com',
        href: 'mailto:jiskelo@gmail.com',
    },
    {
        icon: LocationIcon,
        title: 'Ukraine, Kharkiv',
        href: 'https://goo.gl/maps/LcY7oE2SpdXF4xcHA',
    },
]
